<template src="./template.html" />

<script>
/* eslint-disable */
import _ from 'lodash';
import { mapGetters } from 'vuex';
import Btn from '@/components/elements/buttons';
import InputText from '@/components/elements/inputs/text.vue';
import Calendar from '@/components/elements/inputs/calendar.vue';
import CountrySelect from '@/components/elements/inputs/countrySelect.vue';
import InputSelect from '@/components/elements/inputs/select.vue';
import PhoneSelect from '@/components/elements/inputs/phone.vue';
import Toggle from '@/components/elements/inputs/toggle.vue';
import PlaceHolderComponent from './placeholder.vue';
import ShippingAgentSelect from "@/components/elements/inputs/shippingAgentSelect.vue";
import SubaccountSelect from "@/components/elements/inputs/subaccountSelect.vue";
import FinanceTypeSelect from "@/components/elements/inputs/financeTypeSelect.vue";


export default {
  name: 'Sidebar',
  components: {
    FinanceTypeSelect,
    SubaccountSelect,
    ShippingAgentSelect,
    Btn,
    InputText,
    Calendar,
    CountrySelect,
    InputSelect,
    PhoneSelect,
    Toggle,
    PlaceHolderComponent,
  },
  data() {
    return {
      deleteIconToggle: false,
      deleteFilterToggle: false,
      customFilterName: '',
      formFields: {},
      countries: [],
      additionalOptions: [
        {
          text: `${this.$t('More than')}`,
          value: '>',
        },
        {
          text: `${this.$t('Less than')}`,
          value: '<',
        },
        {
          text: `${this.$t('Equal to')}`,
          value: '=',
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      'get_sidebar_isOpened',
      'get_sidebar_fields',
      'get_sidebar_table_name',
      'get_sidebar_table_api',
      'get_filters_menu',
      'get_is_custom_name',
      'get_active_filter_name',
      'get_is_new_filter',
      'get_table_actions',
      'get_active_filter',
      'get_search_term',
      'get_table_api',
    ]),
  },
  created() {
      for (const [key, value] of Object.entries(this.get_sidebar_fields)) {
        if(this.get_active_filter.hasOwnProperty(key)){
          this.$set(this.formFields, key, this.get_active_filter[key]);
        } else {
          this.$set(this.formFields, key, {
            value: value.value.value,
            additional: ['weight', 'shipments_count'].includes(key) ? '=' : ''
          });
        }
      }
      if(!this.get_is_new_filter) {
        if (this.get_is_custom_name) {
          this.customFilterName = this.get_active_filter_name;
        }
      } else {
        for (const key in this.formFields) {
          this.resetFormFieldKey(key);
        }
      }
  },
  methods: {
    onValueChange(event){
      this.deleteIconToggle = !!this.formFields[event].value
    },
    deleteData(option) {
      this.removeFilterParameter(option);
      this.resetFormFieldKey(option);
      return this.formFields[option].value;
    },
    resetFormFieldKey(key) {
      (
        (typeof this.formFields[key].value === 'object' || Array.isArray(this.formFields[key].value))
        && ['sender_country_id', 'receiver_country_id', 'subaccounts', 'shipping_agents', 'sender_country', 'receiver_country', 'invoiced_differences', 'agreement_differences'].includes(key))
        ? this.formFields[key].value = []
        : this.formFields[key].value = ''
    },
    toggDeleteIcon(val){
      if (!typeof this.formFields[val].value || ((typeof this.formFields[val].value === 'object' || typeof this.formFields[val].value === 'array') && this.formFields[val].value?.length===0)) {
        return false;
      }
      return !!this.formFields[val].value;
    },
    removeFilterParameter(key) {
      this.$store.dispatch('SET_IS_CUSTOM_FILTER_NAME', false);
      this.$store.dispatch('REMOVE_EXISTING_FILTER_PARAM', key).then(() => {
        this.constructURL();
      });
    },
    constructURL() {
      this.$router.push({
        path: this.$route.path,
        query: {
          search: JSON.stringify(this.get_active_filter),
          searchTerm: this.get_search_term,
        },
      });
    },
    selectCountry(val, key) {
      this.formFields[key].value = val;
    },
    selectShippingAgent(val, key) {
      this.formFields[key].value = val;
    },
    selectFinanceType(val, key) {
      this.formFields[key].value = val;
    },
    selectSubaccount(val, key) {
      this.formFields[key].value = val;
    },
    deleteFilter() {
      const newFilters = this.get_filters_menu.filter((filterItem) => {
        if(this.get_active_filter_name !== filterItem.name) {
          return {
            name: filterItem.name,
            params: filterItem.params,
          }
        }
      });
      this.$store.dispatch('DELETE_FILTER', {
        tableName: this.get_sidebar_table_name,
        filters: newFilters,
      }).then(() => {
        this.$store.dispatch('STORE_FILTERS_MENU', newFilters);
        this.$store.dispatch('STORE_ACTIVE_FILTER', {
          name: 'All',
          params: {},
        }).then(() => {
          this.$store.dispatch('TABLE_SEARCH', {
            pageApiURL: this.get_sidebar_table_api,
          }).then((res) => {
            this.$store.dispatch(`CLEAR_${this.get_table_api}`);
            this.$store.dispatch(`STORE_${this.get_table_api}`, res);
            this.constructURL();
          });
          this.closeSidebar();
        });
      });
    },
    saveData() {
      const dataObject = this.loadFilterObject();

      if(_.isEmpty(dataObject) || this.customFilterName === '') return;

      if (!this.get_is_new_filter) {
        // IF EXISTING FILTER
        this.$store.dispatch('EDIT_EXISTING_FILTER', {
          filterIdent: this.get_active_filter_name,
          name: this.customFilterName,
          params: dataObject,
        }).then(() => {
            this.processFilterCreateEdit(dataObject);
        });
      } else {
        // IF NEW FILTER
        this.$store.dispatch('STORE_NEW_FILTER', {
          name: this.customFilterName,
          params: dataObject,
        }).then(() => {
          this.processFilterCreateEdit(dataObject);
          this.$store.dispatch('SET_IS_NEW_FILTER', false);
        });
      }
    },
    processFilterCreateEdit(dataObject) {
      this.$store.dispatch('SAVE_FILTERS', {
        table_name: this.get_sidebar_table_name,
        filters: this.get_filters_menu,
      });
      this.$store.dispatch('STORE_ACTIVE_FILTER', {
        name: this.customFilterName,
        params: dataObject,
      }).then(() => {
        this.$store.dispatch('TABLE_SEARCH', {
          pageApiURL: this.get_sidebar_table_api,
          filter: dataObject,
          searchTerm: this.get_search_term,
        }).then((res) => {
          this.$store.dispatch(`CLEAR_${this.get_table_api}`);
          this.$store.dispatch(`STORE_${this.get_table_api}`, res);
          this.constructURL();
        });
        this.closeSidebar();
      });
    },
    loadFilterObject() {
      let dataObject = {};
      for (const [key] of Object.entries(this.formFields)) {
        const parsedArray = JSON.parse(JSON.stringify(this.formFields[key]))
        if ((Array.isArray(parsedArray.value) && parsedArray.value.length > 0) || (!Array.isArray(parsedArray.value) && parsedArray.value)) {
          dataObject[key] = parsedArray;
        }
      }
      return dataObject
    },
    applyData() {
      const dataObject = this.loadFilterObject();

      this.$store.dispatch('STORE_ACTIVE_FILTER', {
        name: '',
        params: dataObject,
      }).then(() => {
        this.$store.dispatch('TABLE_SEARCH', {
          pageApiURL: this.get_sidebar_table_api,
          filter: dataObject,
          searchTerm: this.get_search_term,
        }).then((res) => {
          this.$store.dispatch(`CLEAR_${this.get_table_api}`);
          this.$store.dispatch(`STORE_${this.get_table_api}`, res);
          this.constructURL();
        });
        this.closeSidebar();
      });

    },
    closeSidebar() {
      this.$store.dispatch('CLOSE_SIDEBAR');
    }
  },
}
</script>
